import { Component, ErrorInfo, PropsWithChildren } from 'react';
import { Button } from '../ui/button';

export type ErrorBoundaryProps = PropsWithChildren<{
  // TODO:
  type?: 'page' | 'component';
}>;

type ErrorBoundaryState =
  | {
      didCatch: true;
      error: Error;
      info: ErrorInfo;
    }
  | {
      didCatch: false;
      error: null;
      info: null;
    };

const initialState: ErrorBoundaryState = {
  didCatch: false,
  error: null,
  info: null,
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }

  static getDerivedStateFromError(error: Error) {
    return { didCatch: true, error };
  }

  resetErrorBoundary() {
    const { error } = this.state;

    if (error !== null) {
      this.setState(initialState);
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ didCatch: true, error, info });
  }

  render() {
    const { children } = this.props;
    const { didCatch, error } = this.state;

    if (didCatch) {
      return (
        <div className="flex flex-col items-center gap-4 p-xl">
          <Button onClick={this.resetErrorBoundary}>点击重新加载</Button>
          <div>异常：{error.message}</div>
        </div>
      );
    }
    return children;
  }
}
